import React, { useEffect, useState } from 'react';
import styles from '../styles';
import { Empty, Form, Row, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { CommonValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { REPORT_REQUEST_ID_LIST } from '../../redux/report-constant';
import { reportSagas } from '../../redux/report-saga';
import { ReportService } from '../../redux/report-service';
import { RBHBox, RBHButton, RBHImage, RBHTable, RBHText, RBHTextInput } from '../../../../../shared/components';
import metrics from '../../../../../shared/theme/metrics';
import styleText from '../../../../../shared/components/rbh-text/styles';
import { MODAL_TYPE } from '../../../../../redux/general/general-constant';
import { generalCreators } from '../../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../../redux/general/general-reducer';
import { reportCreators } from '../../redux/report-action';
import { REPORT_STATE_KEY, reportStateSelector } from '../../redux/report-reducer';
import { Images } from '../../../../../shared/theme';
import './styles.css';

export const AddEditEmailShops: React.FC<Props> = (p) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const emailListShopsData = useSelector(reportStateSelector(REPORT_STATE_KEY.EMAIL_LIST_SHOPS)) as [];
  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    form.validateFields();
    return () => {
      if (history.action === 'POP' && p.onSuccessCallBack) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        history.push('/main/report/manage_email');
      }
    };
  }, [history]);

  const checkFormInvalid = () => {
    let invalid = false;
    const errors = form.getFieldsError();
    for (const field of errors) {
      if (field.errors.length > 0) {
        invalid = true;
        break;
      }
    }
    setFormInvalid(invalid);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const showSuccess = () => {
    dispatch(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_SUCCESS, true));
  };

  const onFinish = () => {
    const resetReload = p.onSuccessCallBack;
    const newListShop = emailListShopsData.map((value: any, i: number) => {
      return {
        shopId: value.shopId,
        emailTo: form.getFieldValue(`shopAddEmailTo-${i}`),
        emailCc: form.getFieldValue(`shopAddEmailCc-${i}`)
      };
    });
    const data = { shops: newListShop };
    dispatch(httpCreators.request({
      id: REPORT_REQUEST_ID_LIST.POST_EMAIL_SHOP,
      sagaHandler: reportSagas.postEmailShopHandler as any,
      callbackParams: { resetReload, showSuccess },
      service: ReportService.postEmailShop,
      serviceParams: data
    }));
  };

  const columnsShop = [
    {
      width: metrics.tableHeader.width250,
      title: <FormattedMessage id={'main.report.table.column3'} />,
      render: (value: any, all: any, index: number) => {
        const shopName = 'shopName-' + index;
        const shopBranchCode = 'branchCode-' + index;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width250 }}>
            <RBHText id={shopName} style={styleText.textRegularFakeBlack}>
              {all.shopName}
            </RBHText>
            <RBHText id={shopBranchCode} style={styles.regular12Gray}>
              {all.branchCode}
            </RBHText>
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width300,
      title:
        <RBHBox>
          <FormattedMessage id={'main.report.addEditEmailShop.table.shop.column2'} />
          <RBHImage style={styles.asterisk} src={Images.asterisk} data-testid={'asterisk-icon'} id={'asterisk-icon'} />
        </RBHBox>,
      render: (value: any, all: any, index: number) => {
        const shopAddEmailTo = `shopAddEmailTo-${index}`;
        const shopAddEmailCc = `shopAddEmailCc-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }}>
            <Form size='large' style={styleText.formText} form={form} onFieldsChange={checkFormInvalid}>
              <Form.Item className={'addEditEmailShop'} colon={false} validateTrigger={['onChange', 'onBlur']}>
                <Form.Item noStyle name={shopAddEmailTo} initialValue={all.emailTo ? all.emailTo : ''}
                  rules={[
                    { pattern: CommonValidator.Email.regexPattern,
                      message: <FormattedMessage id={'main.login.email.format.valid'} /> },
                    { required: true, message: <FormattedMessage id={'main.report.addEditEmailShop.email1.required'} /> },
                    ({ getFieldValue, getFieldError }) => ({
                      validator(_, formValue) {
                        const error = getFieldError(shopAddEmailCc) as any;
                        if (error[0]?.props?.id === 'main.report.addEditEmail.error.dupEmail') {
                          form.validateFields([shopAddEmailCc]);
                        }
                        if (formValue === getFieldValue(shopAddEmailCc)) {
                          form.validateFields([shopAddEmailCc]);
                        }
                        return Promise.resolve();
                      }
                    })
                  ]}>
                  <RBHTextInput id={shopAddEmailTo} placeholder={'main.report.addEditEmailVat.table.vat.column2.emailTo.placeholder'}
                    onBlur={() => trimFieldValue(shopAddEmailTo)} autoComplete='off' data-testid={shopAddEmailTo}
                    style={styles.textBoxEmail} maxLength={CommonValidator.Email.maxLength} />
                </Form.Item>
              </Form.Item>
            </Form>
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width300,
      title: <FormattedMessage id={'main.report.addEditEmailShop.table.shop.column3'} />,
      render: (value: any, all: any, index: number) => {
        const shopAddEmailCc = `shopAddEmailCc-${index}`;
        const shopAddEmailTo = `shopAddEmailTo-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }}>
            <Form size='large' style={styleText.formText} form={form} onFieldsChange={checkFormInvalid}>
              <Form.Item className={'addEditEmailShop'} colon={false} validateTrigger={['onChange', 'onBlur']}>
                <Form.Item noStyle name={shopAddEmailCc} initialValue={all.emailCc ? all.emailCc : ''}
                  rules={[{
                    pattern: CommonValidator.Email.regexPattern,
                    message: <FormattedMessage id={'main.login.email.format.valid'} /> },
                  ({ getFieldValue }) => ({
                    validator(_, formValue) {
                      if (getFieldValue(shopAddEmailTo) === formValue) {
                        return Promise.reject(<FormattedMessage id={'main.report.addEditEmail.error.dupEmail'} />);
                      }
                      return Promise.resolve();
                    }
                  })
                  ]}>
                  <RBHTextInput id={shopAddEmailCc} placeholder={'main.report.addEditEmailVat.table.vat.column3.emailCc.placeholder'}
                    onBlur={() => trimFieldValue(shopAddEmailCc)} autoComplete='off' data-testid={shopAddEmailCc}
                    style={styles.textBoxEmail} maxLength={CommonValidator.Email.maxLength} />
                </Form.Item>
              </Form.Item>
            </Form>
          </RBHBox>
        );
      }
    }
  ];

  const tableEmailListShopRender = () => {
    return (
      <RBHTable
        locale={{
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span> <FormattedMessage id={'main.table.notFound'} /> </span>} />
        }}
        scroll={{ y: 360 }}
        rowKey={'shopId'}
        columns={columnsShop}
        dataSource={emailListShopsData}
        pagination={false}>
      </RBHTable>
    );
  };

  const remarkRender = () => {
    return (
      <Row justify={'space-between'}>
        <RBHBox>
          <RBHText data-testid='manageEmail-remark' id='manageEmail-remark' style={styles.remarkText}
            text={'main.report.manageEmail.remark'} />
          <RBHText data-testid='manageEmail-remark1' id='manageEmail-remark1' style={styles.remarkText}
            text={'main.report.manageEmail.remark1'} />
          <RBHText data-testid='manageEmail-remark2' id='manageEmail-remark2' style={styles.remarkText}
            text={'main.report.manageEmail.remark2'} />
          <RBHText data-testid='manageEmail-remark3' id='manageEmail-remark3' style={styles.remarkText}
            text={'main.report.manageEmail.remark3'} />
          <RBHText data-testid='manageEmail-remark4' id='manageEmail-remark4' style={styles.remarkText}
            text={'main.report.manageEmail.remark4'} />
        </RBHBox>
        <RBHBox>
          <Space size={'middle'}>
            <RBHButton
              id={'addEditEmailShop-cancel-btn'}
              style={styles.buttonFromCancelGradient}
              type='primary'
              htmlType='button'
              onClick={() => {
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  clickClosable: false,
                  escClosable: false,
                  onOk: p.onSuccessCallBack,
                  type: MODAL_TYPE.CONFIRM_EDIT
                }));
              }}
              text={'main.report.addEditEmailVat.cancelButton'}
              data-testid={'addEditEmailShop-cancel-btn'} />
            <RBHButton id={'addEditEmailShop-ok-btn'} style={styles.buttonFromConfirmGradient}
              type='primary'
              htmlType='button'
              onClick={() => { onFinish(); }}
              disabled={formInvalid}
              text={'main.report.addEditEmailVat.okButton'}
              data-testid={'addEditEmailShop-ok-btn'} />
          </Space>
        </RBHBox>
      </Row>

    );
  };

  return (
    <RBHBox>
      <RBHBox style={styles.tablesContent}>
        {tableEmailListShopRender()}
      </RBHBox>
      {remarkRender()}
    </RBHBox>
  );
};

interface Props {
  onSuccessCallBack?: any;
}
